export default __webpack_public_path__ + "static/media/offer-vertical-chocolate@3x.2a2ef6d7.png";